import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'q-mobile-frame',
  templateUrl: './q-mobile-frame.component.html',
  styleUrls: ['./q-mobile-frame.component.scss']
})
export class MobileFrameComponent implements OnInit {
  @Input() content: any = '';
  // @Input() hoverOver = true;
  // @Output() onHoverClick = new EventEmitter();

  constructor() { }

  ngOnInit(){  }


  // hoverClick($event) {
  //   this.onHoverClick.emit($event);
  // }

}
